module.exports = __webpack_public_path__ + "static/img/modifypass.d2f90fa8.png";